import * as React from 'react';
import { FormField, Header1 } from '@cian/ui-kit';
import * as styles from './Summary.css';

interface ISummaryProps {
  loanPayment: string;
  requiredIncome: string;
  banks: React.ReactElement;
}
export function Summary({ loanPayment, requiredIncome, banks }: ISummaryProps) {
  return (
    <div>
      <FormField label="Ежемесячный платеж">
        <Header1>{loanPayment}</Header1>
      </FormField>
      <FormField label="Необходимый доход">
        <Header1>{requiredIncome}</Header1>
      </FormField>

      <div className={styles['banks']}>
        <FormField label="Банки-партнёры" withoutMargin>
          {banks}
        </FormField>
      </div>
    </div>
  );
}
